import type { DeliveryEstimateAddress, DeliveryEstimateAddressResponse, ItemUI } from '@libs/common-node';
import type { Nullable } from '@libs/core';
import { getLocale, HttpMethod } from '@libs/core';
import { typedFetch } from './typedFetch';
import { getNextApiRoute } from './api';

const locale = getLocale();

const DELIVERY_BASE_URL = getNextApiRoute('delivery');

export const getDeliveryEstimate = async (
    address: Nullable<DeliveryEstimateAddress>,
    item: ItemUI
): Promise<DeliveryEstimateAddressResponse | undefined> => {
    const pickup = new Date();
    pickup.setDate(pickup.getDate() - 1); // This is how demandware calculated pickup date. Copied same logic for CPC-3833.

    const body = JSON.stringify({
        input: {
            dropoff_address: address,
            productId: item.sku,
            order_value: `${item.totalPrice}`,
            pickup_time: pickup.toISOString(),
        },
        locale,
    });

    const result: DeliveryEstimateAddressResponse | null = await typedFetch(`${DELIVERY_BASE_URL}/estimate`, {
        method: HttpMethod.POST,
        body,
    });

    if (result?.store) {
        result.store.StoreNumber = String(result.store.StoreNumber).padStart(4, '0');
    }

    return result || undefined;
};
